import { faMinus } from "@jewlr/pro-light-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-light-svg-icons/faPlus"
import PropTypes from "prop-types"
import { useState } from "react"

import Button from "components/ui/button"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const FooterAccordion = ({ children, id, subAccordion, title }) => {
  const [show, toggleShow] = useState(false)
  const HeadingTag = subAccordion ? "h5" : "h6"

  return (
    <div
      className={cn("border-grey-30", subAccordion ? "border-b" : "border-t")}
    >
      <HeadingTag>
        <Button
          aria-controls={id}
          aria-expanded={show}
          className="flex w-full items-center justify-between py-16 focus:outline-none"
          onClick={() => toggleShow(!show)}
          text
          variant="secondary"
        >
          <p
            className={cn(
              "text-14 leading-16 font-medium capitalize",
              subAccordion
                ? "tablet:text-12 tablet:leading-14 tablet:text-black"
                : ""
            )}
          >
            {title}
          </p>
          <FontAwesomeIcon className="w-10" icon={show ? faMinus : faPlus} />
        </Button>
      </HeadingTag>
      <Expand id={id} show={show}>
        {children}
      </Expand>
    </div>
  )
}

FooterAccordion.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  subAccordion: PropTypes.bool,
  title: PropTypes.string,
}

export default FooterAccordion
